import { EMR_APIS } from "@/api_framework/api_config";
import {
  IRxMedicinePrescriptionUpdateBody,
  IRxMedicinePrescriptionUpdateResponse,
} from "@/api_framework/api_modals/EMRs";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});

export const useUpdateRxMedicinePrescriptionAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async (payload: IRxMedicinePrescriptionUpdateBody) => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key) as string;

      const response = await axios
        .post(`${EMR_APIS?.CREATE_MEDICINE_PRESCRIPTION?.baseURL}`, payload, {
          headers: {
            Authorization: accessToken,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IRxMedicinePrescriptionUpdateResponse>) => {
          if (res?.data?.status) {
            return {
              status: true,
              message: res?.data?.message ?? "Medicine prescription updated successfully",
              data: res?.data?.data ?? null,
            };
          }

          return {
            status: false,
            message: res?.data?.message ?? "Unable to update medicine prescription",
            data: res?.data?.data ?? null,
          };
        })
        .catch((e: AxiosError<IRxMedicinePrescriptionUpdateResponse>) => {
          sendCurl(e?.config?.["curlCommand"]);
          const errorMessage = e?.response?.data?.message ?? "Unable to update medicine prescription";
          toast.error(errorMessage);
          return { status: false, message: errorMessage, data: null };
        });

      return response;
    } catch (e: any) {
      const errorMessage = "Server Error: " + e?.message;
      toast.error(errorMessage);
      return { status: false, message: errorMessage, data: null };
    }
  }, [configuration, sendCurl]);

  return execute;
};
